import { render, staticRenderFns } from "./WachBt.vue?vue&type=template&id=e53f8dac&scoped=true&"
import script from "./WachBt.vue?vue&type=script&lang=js&"
export * from "./WachBt.vue?vue&type=script&lang=js&"
import style0 from "./WachBt.vue?vue&type=style&index=0&id=e53f8dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f8dac",
  null
  
)

export default component.exports